import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';

import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_alertdialog');

register('wm-alertdialog', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmAlertDialog #${counter}="wmAlertDialog" role="alertdialog" wm-navigable-element="true" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
